module.exports = __webpack_public_path__ + "static/media/OpenSauceTwo-Regular.c5265d48.ttf";